import React from 'react';
import { Avatar, AvatarFallback } from './ui/avatar';
import { getUserInitials } from '../utils/user-initials';
import { cn } from '../lib/utils';

type UserAvatarProps = {
  email?: string | null;
  className?: string;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ email, className }) => {
  return (
    <Avatar className={cn('h-8 w-8', className)}>
      <AvatarFallback className="bg-[var(--scribane-black)] text-white">
        {getUserInitials(email)}
      </AvatarFallback>
    </Avatar>
  );
};
